import { ColetaFaturaEstado, ColetaFluxoResultado } from '../../types/coleta';

export const TEXTO_FATURA_PULADA =
  'Os dados da fatura não foram coletados porque o número do administrador já foi encontrado nas linhas do contrato.';

export const TEXTO_FATURA_ABERTA_SEM_CONTATO =
  'A fatura foi aberta e o número do administrador não foi encontrado.';

export function estadoDaFatura(resultado?: Pick<ColetaFluxoResultado, 'fatura'> | null): ColetaFaturaEstado {
  const estado = resultado?.fatura?.estado;
  if (
    estado === 'pulada_admin_nas_linhas'
    || estado === 'aberta_sem_contato'
    || estado === 'aberta_com_contato'
    || estado === 'nao_aplicavel'
  ) {
    return estado;
  }
  return 'nao_aplicavel';
}

export function visaoFaturaP2b(
  estado: ColetaFaturaEstado,
  opcoes: { podeAcionar: boolean; inadimplente?: boolean; temContatos?: boolean; temLemit?: boolean },
): { mostrar: boolean; mensagem: string; mostrarTabela: boolean; mostrarBotao: boolean } {
  if (opcoes.inadimplente && !opcoes.temContatos && !opcoes.temLemit) {
    return { mostrar: false, mensagem: '', mostrarTabela: false, mostrarBotao: false };
  }
  if (estado === 'pulada_admin_nas_linhas') {
    return {
      mostrar: true,
      mensagem: TEXTO_FATURA_PULADA,
      mostrarTabela: false,
      mostrarBotao: opcoes.podeAcionar,
    };
  }
  if (estado === 'aberta_sem_contato') {
    return {
      mostrar: true,
      mensagem: TEXTO_FATURA_ABERTA_SEM_CONTATO,
      mostrarTabela: true,
      mostrarBotao: false,
    };
  }
  return {
    mostrar: !opcoes.inadimplente || Boolean(opcoes.temContatos) || Boolean(opcoes.temLemit),
    mensagem: '',
    mostrarTabela: true,
    mostrarBotao: false,
  };
}
